import styles from "./buttons.module.css";

export const BtnLink = ({ text, handleClick, className = "", disabled, title }) => {
	return (
		<button
			className={`${styles.BtnLink} ${className} btn`}
			disabled={disabled}
			onClick={handleClick}
			title={title}>
			{text}
		</button>
	);
};
